import React from 'react';
import { get, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { withSize } from '@bd/bdcore-utilities';

import { BtnAnimationSheen } from '../../helpers/UIElements';
import PlanCard from '../../components/PlanCard';
import { colors } from '../../styles';

const styles = css`
  .PlansResults_wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .PlansMore_btnWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 0;
    @media(min-width: 992px) {
      padding: 45px 0;
    }
  }
  .PlansMore_btn {
    height: 45px;
    padding: 0 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    cursor: pointer;
    @media(min-width: 992px) {
      height: 55px;
      padding: 0 35px;
      font-size: 17px;
      letter-spacing: 0;
    }
    &:focus {
      outline: none;
    }
  }
`;

function PlansResults({ plans, sort, limit, Increment, showMorePlans, size }) {
  const imagesLeft = `${limit + Increment > plans.length ? plans.length - limit : Increment}`;
  return (
    <div className={styles}>
      <div className="PlansResults_wrapper">
        {
          orderBy(plans, sort.field, get(sort, 'dir', 'asc')).slice(0, limit).map((plan, i) => (
            <div key={plan._id} className="">
              <PlanCard plan={plan} index={i} />
            </div>
          ))
        }
      </div>
      {
        limit < plans.length &&
        <div className="PlansMore_btnWrapper">
          <span className="PlansMore_text">Showing {limit} of {plans.length} Floor Plans</span>
          <BtnAnimationSheen className="PlansMore_btn mt-3" onClick={showMorePlans} role="button" tabIndex={0}>{`Load${size.width >= 992 ? ` ${imagesLeft}` : ''} More${size.width >= 992 ? ' Floor Plans' : ''}`}</BtnAnimationSheen>
        </div>
      }
    </div>
  );
}

PlansResults.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
  limit: PropTypes.number.isRequired,
  showMorePlans: PropTypes.func.isRequired,
  Increment: PropTypes.number.isRequired,
  size: PropTypes.object.isRequired,
};

PlansResults.defaultProps = {
  listView: false,
};

export default withData(
  {
    plans: true,
  },
)(withSize()(PlansResults));



// WEBPACK FOOTER //
// ./src/pages/Plans/PlansResults.js